/** Coordinated panel + body reveal for ContentListPage detail routes. */
export type ContentListPageRevealPhase = 'waiting' | 'ready';

export function resolveContentListPageRevealPhase(
  ready: boolean,
): ContentListPageRevealPhase {
  return ready ? 'ready' : 'waiting';
}

export function usesCoordinatedContentListReveal(
  hasPanel: boolean,
  contentReady: boolean | undefined,
): contentReady is boolean {
  return hasPanel && contentReady !== undefined;
}

interface ResolveContentListPageChromeReadyInput {
  coordinatedReveal: boolean;
  contentReady: boolean | undefined;
  listContentReady: boolean;
  hasListState: boolean;
  hasBodyContent: boolean;
}

/** SSOT gate for bottom chrome (CTA, site footer) on ContentListPage. */
export function resolveContentListPageChromeReady({
  coordinatedReveal,
  contentReady,
  listContentReady,
  hasListState,
  hasBodyContent,
}: ResolveContentListPageChromeReadyInput): boolean {
  if (coordinatedReveal) {
    return Boolean(contentReady);
  }

  if (hasListState) {
    return listContentReady;
  }

  return hasBodyContent;
}
